export default "__VITE_ASSET__BJAEWbpW__"